import React from 'react';
import styles from '@/Home/ui/atoms/NoBillingPermissionImage.module.scss';
import ImagenNursery from '@/Shared/ui/assets/imagen_nursery.png';
import ImagenRestaurant from '@/Shared/ui/assets/imagen_restaurant.png';

export const NoBillingPermissionImage: React.FC<{isNursery: boolean}> = (props) => (
  <div className={styles.noBillingImageContainer}>
    <img
      src={props.isNursery ? ImagenNursery : ImagenRestaurant}
      alt={props.isNursery ? "Nursery" : "Restaurant"}
      className={styles.noBillingImage}
    />
  </div>
);
